import React from 'react';
import { Tooltip } from 'seagull';
import { QboIcon } from "../../integrations/QBO/QboIcon";
import { invoiceIntegrationModel, timeModel } from "../../models";
function getTooltip(integration) {
  switch (integration.status) {
    case invoiceIntegrationModel.Status.PendingSync:
      return 'Pending invoice sync';
    case invoiceIntegrationModel.Status.InvoiceSyncFailed:
      return 'Invoice sync failed';
    case invoiceIntegrationModel.Status.PaymentSyncFailed:
      return 'Payment sync failed';
    case invoiceIntegrationModel.Status.RefundSyncFailed:
      return 'Refund sync failed';
    case invoiceIntegrationModel.Status.InvoiceRecorded:
    case invoiceIntegrationModel.Status.VoidedRecorded:
      return "Invoice recorded in QuickBooks Online on ".concat(timeModel.formatDateWithTime(integration.date));
    case invoiceIntegrationModel.Status.RefundRecorded:
      return "Refund recorded in QuickBooks Online on ".concat(timeModel.formatDateWithTime(integration.date));
    case invoiceIntegrationModel.Status.PaymentRecorded:
      return "Payment recorded in QuickBooks Online on ".concat(timeModel.formatDateWithTime(integration.date));
  }
}
function getIcon(integration) {
  if (invoiceIntegrationModel.isSynced(integration)) {
    return /*#__PURE__*/React.createElement(QboIcon, null);
  } else if (invoiceIntegrationModel.isSyncFailed(integration)) {
    return /*#__PURE__*/React.createElement(QboIcon, {
      intent: "error"
    });
  } else if (invoiceIntegrationModel.isPendingSync(integration)) {
    return /*#__PURE__*/React.createElement(QboIcon, {
      intent: "pending"
    });
  } else {
    return null;
  }
}
export function InvoiceQboIntegrationStatus(props) {
  const {
    className,
    testid,
    integration,
    placement = 'top'
  } = props;
  return integration ? /*#__PURE__*/React.createElement("div", {
    "data-testid": testid,
    className: className
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(testid, "-tooltip")
    }, getTooltip(integration)),
    placement: placement
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline'
    }
  }, getIcon(integration)))) : null;
}